import {Tooltip} from "@progress/kendo-react-tooltip"
import {useDispatch} from "react-redux"
import {
    CustomPrice,
    setSelectedCustomPricingId,
    setSelectedCustomPricingName,
    showAddEditCustomersModal,
} from "../../containers/CustomPrices/customPricesSlice"

const CPCustomers = ({customPrice}: {customPrice: CustomPrice}) => {
    const dispatch = useDispatch()

    const addCustomers = (customPricingId: number) => {
        dispatch(showAddEditCustomersModal(true))
        dispatch(setSelectedCustomPricingId(customPricingId))
        dispatch(setSelectedCustomPricingName(customPrice.customPricingName))
    }

    return (
        <div>
            {customPrice.pricingCustomers.map(
                (pricingCustomer, ind) =>
                    ind <= 3 && (
                        <Tooltip key={`cust_item_${ind}`} openDelay={100} position="bottom" anchorElement="pointer">
                            <div className="pt-2 text-overflow-wrap" title={pricingCustomer}>
                                {pricingCustomer}
                            </div>
                        </Tooltip>
                    ),
            )}
            <div className={`clip-text font-weight-bold ps-0 ${customPrice.active ? "pb-0" : "k-disabled"}`}>
                <span
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        customPrice.active && addCustomers(customPrice.customPricingID)
                    }}
                >
                    ...
                </span>
            </div>
        </div>
    )
}

export default CPCustomers
